import { useDebounce } from "@uidotdev/usehooks";
import { useState } from "react";
import { SearchOrganization200, SearchOrganizationType } from "~/api/model";
import { useSearchOrganization } from "~/api/search/search";
import { trackEvent } from "~/utils/analytics";

type UseSearchProps = {
  organizationId: string;
};

export const useSearch = ({ organizationId }: UseSearchProps) => {
  const [search, setSearch] = useState("");
  const debouncedSearch = useDebounce(search, 500);

  const { data, isLoading } = useSearchOrganization<
    SearchOrganization200,
    boolean
  >(
    organizationId,
    {
      query: debouncedSearch,
      type: SearchOrganizationType.all,
    },
    {
      query: {
        enabled: debouncedSearch.length > 0,
      },
    }
  );

  const clearSearch = () => {
    trackEvent({ eventName: "app/search_modal/clear.button/click" });
    setSearch("");
  };

  return {
    search,
    setSearch,
    clearSearch,
    data,
    isLoading,
  };
};
